import request from '@/request'

export function send(data) {
  return request({
    url: '/index/Send',
    method: 'post',
    data
  })
}

